import { combineReducers } from "redux";
import aiReducer from "./Reducers/aiReducer";

const rootReducer = combineReducers({
  ai: aiReducer,
});

export default rootReducer;
